import React, { Fragment } from 'react';
import { Box, Dialog, Divider, Grid, IconButton, Stack, styled, Typography } from '@mui/material';
import styles from '../../../../../../../custom/style.module.css';
import { CustomButton, CustomDialogAction, CustomDialogContent, CustomDialogTitle, StyledCard } from '../../../../../../../custom/components';
import { CloseIconBtn } from 'custom/constants';
import dayjs from 'dayjs';
import { DateCalendar, PickersDay } from '@mui/x-date-pickers';
import importStyles from './servicecatalog.module.css';
import { Close } from '@mui/icons-material';

const SelectHolidayModal = (props) => {

  const HighlightedDay = styled(PickersDay)(({ theme }) => ({
    '&.Mui-selected': {
      backgroundColor: '#59b36247',
      color: theme.palette.common.black,
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
        border: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
      },
      '&:focus': {
        backgroundColor: theme.palette.secondary.main,
        border: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
      },
    },
  }));
  
  const renderHolidays = (selectedHolidays) => {
    const years = [...new Set(selectedHolidays.map(holiday => dayjs(holiday).year()))];
    const year_months = years.map(year =>
      Array.from({ length: 12 }, (_, i) => {
        const month = String(i + 1).padStart(2, '0');
        return `${year}-${month}`;
      })
    );
    const split_year = year_months.map((monthArr) => {
      const firstFourMonths = monthArr.slice(0, 4);   // Jan - Apr
      const secondFourMonths = monthArr.slice(4, 8);  // May - Aug
      const thirdFourMonths = monthArr.slice(8);      // Sep - Dec
      return [firstFourMonths, secondFourMonths, thirdFourMonths];
    });
    return years.map((year, yearIdx) => (
      <Fragment key={yearIdx}>
        <Grid item sm={12} md={12} lg={'auto'}>
          <Typography variant='h5' color={'primary'} mb={2} textTransform='uppercase' fontWeight={600} textAlign='center'>
            {year}
          </Typography>
          {split_year[yearIdx].map((half, halfIndex) => (
            <Fragment key={halfIndex}>
              <Grid container spacing={3} alignItems={'flex-start'} className={importStyles.datesWrapper}>
                {half
                  .filter(month => dayjs(month).year() === year)
                  .map((month, index) => (
                    <Fragment key={index}>
                      <Grid item xs={12} sm={6} md={3} lg={3} minWidth={'140px'}>
                        <Stack direction='column' spacing={0} alignItems='center' className={importStyles.monthWrapper}>
                          <Typography
                            variant='body2'
                            textTransform='uppercase'
                            fontWeight={700}
                            p={0.2}
                            minWidth={'40px'}
                            color= 'var(--primaryblue)'
                            bgcolor= '#dfdfdf'
                            borderBottom={'1px solid var(--primaryblue)'}
                            marginBottom= '11px'
                            borderRadius='4px 4px 00 0'
                            width={'100%'}
                            textAlign={'center'}
                          >{dayjs(month).format('MMM')}</Typography>

                          {/* No Dates Selected */}
                          {selectedHolidays.some(hol => dayjs(hol).format('YYYY-MM') === month) ? '' : (
                            <Typography variant='body1'  minHeight={'47px'}>-</Typography>
                          )}

                          <Stack direction='row' spacing={1} flexWrap={'wrap'}>
                            {selectedHolidays
                              .filter(
                                holiday =>
                                  dayjs(holiday).year() === year &&
                            dayjs(holiday).format('YYYY-MM') === month
                              )
                              .sort((a, b) => new Date(a) - new Date(b))
                              .map((holiday, index) => (
                                <Stack key={index} direction='column' alignItems='center' spacing={0}>
                                  <div className={styles.positionRelative}>
                                    <Typography variant='body2' fontWeight={700} className={importStyles.date}>
                                      {dayjs(holiday).format('DD')}
                                    </Typography>
                                    <IconButton
                                      size='small'
                                      onClick={() => props.removeHoliday(holiday)}
                                      className={importStyles.removeHoliday}
                                      disableRipple
                                    >
                                      <Close sx={{ fontSize: 12 }} />
                                    </IconButton>
                                  </div>
                                  <Typography variant='caption' color={'text.secondary'}>
                                    {dayjs(holiday).format('ddd')}
                                  </Typography>
                                </Stack>
                              ))}
                          </Stack>
                        </Stack>
                        <Divider orientation='vertical' flexItem className={importStyles.divider} />
                      </Grid>
                    </Fragment>
                  ))}
              </Grid>
            </Fragment>
          ))}
        </Grid>
      </Fragment>
    ));
  };

  //higlight the dates in highlightedDays array
  const SelectedDay = (props) => {
    const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;

    const isSelected =
    !props.outsideCurrentMonth &&
    highlightedDays.includes(day.format('YYYY-MM-DD'));

    return (
      <HighlightedDay
        {...other}
        outsideCurrentMonth={outsideCurrentMonth}
        day={day}
        selected={isSelected}
      />
    );
  };

  return (
    <div>
      <Dialog
        aria-labelledby='form-dialog-title'
        open={props.modal == 'holidays'}
        onClose={props.onClose}
        maxWidth={'lg'}
        fullWidth
        scroll='paper'>
        <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>
          Holidays List
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <form onReset={props.onClose} className={styles.w100} onSubmit={props.handleSubmitHolidays}>
          <CustomDialogContent className={importStyles.holidayModal}>
            <StyledCard>
              <Stack direction='row' alignItems='flex-start' justifyContent='center' flexWrap='wrap' >
                <Grid container spacing={4} direction='row' alignItems={'flex-start'} justifyContent='center' maxWidth={'700px'}
                  order={{
                    xs: 2,
                    lg: 1,
                  }}>
                  {renderHolidays(props.selectedHolidays)}
                </Grid>
                <Box order={{
                  xs: 1,
                  lg: 2,
                }} flex={1}>
                  <DateCalendar
                    className={importStyles.datePicker}
                    onChange={props.handleHolidays}
                    slotProps={{ 
                      actionBar: { actions: [] },
                      day: { highlightedDays: props.selectedHolidays,  },
                    }}
                    slots={{ day: SelectedDay }}
                  />
                </Box>
              </Stack>
            </StyledCard>
          </CustomDialogContent>
          <CustomDialogAction className={`${styles.fSpaceBtw}`}>
            <CustomButton variant='contained' type='reset' className={importStyles.actionButton}> Close</CustomButton>
            <CustomButton variant='contained' type='submit' className={importStyles.actionButton}>Submit</CustomButton>
          </CustomDialogAction>
        </form>
      </Dialog>
    </div>
  );
};
export default SelectHolidayModal;